<template>
  <div style="position: relative; width: 100%">
    <el-row>
      <el-col :span="24">
        <el-radio-group v-model="isApplyAll"
                        fill="#ff0000"
                        @change="onApplyTypeChange()">
          <el-radio :label="true">{{ $t('all') }}</el-radio>
          <el-radio :label="false">{{ $t('specific') }}</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>
    <div style="position: relative">
      <div v-if="isApplyAll === true"
          class="overlay"></div>
      <el-table
        id="market-agent-list-table"
        :data="roomTypeDataSourceList"
        header-row-class-name="table-header-color"
        style="width: 100%">
        <el-table-column
          label=""
          width="50">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.isCheck" @change="onSelectRoomTypeChange()"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column
          prop="code"
          :label="$t('code')">
        </el-table-column>
        <el-table-column
          prop="name"
          :label="$t('name')">
        </el-table-column>
        <el-table-column
          prop="status"
          :label="$t('status')" width="80px">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === STATUS.ENABLE ? 'success' : 'danger'" size="mini" disable-transitions>
              {{ getPromotionStatus(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import i18nMessages from '@/translations/Hotel/ManageHotel/Promotion/components/ApplyRoomTypeComponent.i18n'
import { getStatusName } from '@/helpers'
import { STATUS } from '@/configs/constant'
export default {
  name: 'PromotionApplyRoomType',
  i18n: { messages: i18nMessages },
  props: {
    roomTypeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    selectedRoomTypeIdList: {
      type: Array,
      default: () => {
        return undefined
      }
    }
  },
  data () {
    return {
      STATUS,
      roomTypeDataSourceList: [],
      isApplyAll: true
    }
  },
  created: function () {
    this._prepareRoomTypeDataSourceList()

    if (this.selectedRoomTypeIdList !== undefined) {
      this.isApplyAll = false
    }
  },
  methods: {
    onSelectRoomTypeChange: function () {
      const selectedRoomTypeIdList = this._getSpecificRoomTypeIdList()
      this.$emit('onSelectRoomTypeChange', selectedRoomTypeIdList)
    },
    onApplyTypeChange: function () {
      let selectedRoomTypeIdList = []
      if (this.isApplyAll === true) {
        selectedRoomTypeIdList = undefined
      } else {
        selectedRoomTypeIdList = this._getSpecificRoomTypeIdList()
      }
      this.$emit('onSelectRoomTypeChange', selectedRoomTypeIdList)
    },
    getPromotionStatus: function (status) {
      return this.$t(getStatusName(status))
    },
    _getSpecificRoomTypeIdList: function () {
      const selectedRoomTypeList = this.roomTypeDataSourceList.filter((item) => {
        return item.isCheck
      })
      const selectedRoomTypeIdList = selectedRoomTypeList.map(item => item.id)

      return selectedRoomTypeIdList
    },
    _prepareRoomTypeDataSourceList: function () {
      this.roomTypeList.forEach((roomType) => {
        const roomTypeDataSource = {
          id: roomType.id,
          name: roomType.name,
          code: roomType.code,
          status: roomType.isEnable,
          isCheck: this._checkIsSelectedRoomType(roomType.id)
        }
        this.roomTypeDataSourceList.push(roomTypeDataSource)
      })
    },
    _checkIsSelectedRoomType: function (roomTypeId) {
      if (this.selectedRoomTypeIdList === undefined) {
        return false
      }

      return this.selectedRoomTypeIdList.includes(roomTypeId)
    }
  }
}
</script>
<style scoped>
  .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #cccccc;
    z-index: 2;
    opacity: 0.5;
    filter: alpha(opacity=50);
  }
</style>
